<template>
    <AppLayout>
        <div class="container">

            <!-- Welcome Back Card -->
            <div class="row">
                <div class="col-md-12">
                    <div class="card" id="welcome-card">
                        <div class="card-body py-4">
                            <div class="left">
                                <h2 class="card-title">Welcome Back! Keith </h2>
                                <p class="card-text subtitle">This is your dashboard where you can manage your activities.</p>
                            </div>
                            <div class="avatar">KT</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- My Membership details cards  -->
            <div class="row mt-4">

                <!-- Membership Status -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-info"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Membership Status </span>
                                <h6 class="bold text-primary">Active</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Days Until renewal -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-alarm"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Days Until Renewal</span>
                                <h6 class="bold text-primary">30</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Certificate Status -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-patch-check"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Certificate Status</span>
                                <h6 class="bold text-primary">Valid</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Membership Type -->
                <div class="col-md-3">
                    <div class="card stats_card">
                        <div class="card-body">
                            <div class="icon">
                                <i class="bi bi-person"></i>
                            </div>
                            <div class="details">
                                <span class="subtitle">Membership Type</span>
                                <h6 class="bold text-primary">Individual</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Actions -->
            <div class="row mt-4">

                <!-- Membership details -->
                <div class="col-md-8">
                    <div class="card h-100">
                        <div class="card-body">
                            <h5 class="bold">Membership Details</h5>

                            <div class="row pt-4">
                                <!-- Membership Number -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Membership Number</span>
                                    <h6 class="bold">ICDGP12345</h6>
                                </div>

                                <!-- Type -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Membership Type</span>
                                    <h6 class="bold">Individual</h6>
                                </div>

                                <!-- Start date -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Start Date</span>
                                    <h6 class="bold">2025-10-01</h6>
                                </div>

                                <!-- Expiry Date -->
                                <div class="item col-md-6 mt-3">
                                    <span class="subtitle">Expiry Date</span>
                                    <h6 class="bold">2026-10-01</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- My certificate -->
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="bold">My Certificate</h5>

                            <div class="inner text-center">
                                <div class="avatar mb-3">IC</div>
                                <span class="subtitle">Certificate Number</span>
                                <h6 class="bold mb-3">ICDGP12345</h6>
                                <p class="subtitle mt-2 display-6">Issued on: 2025-10-01 <br> Valid until: 2026-10-01</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Learning & Professional Development -->
            <div class="row mt-4">
                <!-- Course Progress -->
                <div class="col-md-6 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Learning Progress</h5>
                                <a href="#" class="btn btn-sm btn-outline-primary">View All</a>
                            </div>

                            <!-- Current Courses -->
                            <div class="course-item mb-3">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">Cybersecurity Fundamentals</h6>
                                    <span class="badge bg-primary">75%</span>
                                </div>
                                <div class="progress mb-2" style="height: 6px;">
                                    <div class="progress-bar bg-primary" style="width: 75%"></div>
                                </div>
                                <small class="text-muted">3 of 4 modules completed</small>
                            </div>

                            <div class="course-item mb-3">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">GDPR Compliance</h6>
                                    <span class="badge bg-success">100%</span>
                                </div>
                                <div class="progress mb-2" style="height: 6px;">
                                    <div class="progress-bar bg-success" style="width: 100%"></div>
                                </div>
                                <small class="text-muted">Certificate earned</small>
                            </div>

                            <div class="course-item">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0">Risk Management</h6>
                                    <span class="badge bg-warning">25%</span>
                                </div>
                                <div class="progress mb-2" style="height: 6px;">
                                    <div class="progress-bar bg-warning" style="width: 25%"></div>
                                </div>
                                <small class="text-muted">Started 2 days ago</small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CPD & Professional Development -->
                <div class="col-md-6 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Professional Development</h5>
                                <a href="#" class="btn btn-sm btn-outline-success">Track CPD</a>
                            </div>

                            <!-- CPD Hours -->
                            <div class="row text-center mb-4">
                                <div class="col-4">
                                    <div class="cpd-stat">
                                        <h4 class="text-primary mb-0">28</h4>
                                        <small class="text-muted">CPD Hours</small>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="cpd-stat">
                                        <h4 class="text-success mb-0">5</h4>
                                        <small class="text-muted">Certificates</small>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="cpd-stat">
                                        <h4 class="text-info mb-0">12</h4>
                                        <small class="text-muted">Badges</small>
                                    </div>
                                </div>
                            </div>

                            <!-- Recent Achievements -->
                            <h6 class="bold mb-3">Recent Achievements</h6>
                            <div class="achievement-item mb-2">
                                <div class="d-flex align-items-center">
                                    <div class="badge bg-warning rounded-circle me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                        <i class="bi bi-award"></i>
                                    </div>
                                    <div>
                                        <h6 class="mb-0">GDPR Expert</h6>
                                        <small class="text-muted">Earned 2 days ago</small>
                                    </div>
                                </div>
                            </div>
                            <div class="achievement-item">
                                <div class="d-flex align-items-center">
                                    <div class="badge bg-info rounded-circle me-3" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
                                        <i class="bi bi-shield-check"></i>
                                    </div>
                                    <div>
                                        <h6 class="mb-0">Security Champion</h6>
                                        <small class="text-muted">Earned 1 week ago</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Community & Quick Actions -->
            <div class="row mt-4">
                <!-- Community Activity -->
                <div class="col-md-8 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Community & Events</h5>
                                <a href="#" class="btn btn-sm btn-outline-info">View Forums</a>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <h6 class="bold mb-3">Upcoming Events</h6>
                                    <div class="event-item mb-3">
                                        <div class="d-flex">
                                            <div class="event-date me-3">
                                                <div class="text-center bg-primary text-white rounded p-2">
                                                    <div style="font-size: 0.8rem;">Sep</div>
                                                    <div style="font-weight: bold;">25</div>
                                                </div>
                                            </div>
                                            <div>
                                                <h6 class="mb-1">Cybersecurity Webinar</h6>
                                                <small class="text-muted">2:00 PM - 3:30 PM</small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="event-item mb-3">
                                        <div class="d-flex">
                                            <div class="event-date me-3">
                                                <div class="text-center bg-success text-white rounded p-2">
                                                    <div style="font-size: 0.8rem;">Oct</div>
                                                    <div style="font-weight: bold;">02</div>
                                                </div>
                                            </div>
                                            <div>
                                                <h6 class="mb-1">GDPR Workshop</h6>
                                                <small class="text-muted">10:00 AM - 12:00 PM</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <h6 class="bold mb-3">Forum Activity</h6>
                                    <div class="forum-item mb-3">
                                        <h6 class="mb-1">Latest Security Threats Discussion</h6>
                                        <small class="text-muted">15 new replies • 2 hours ago</small>
                                    </div>
                                    <div class="forum-item mb-3">
                                        <h6 class="mb-1">ISO 27001 Implementation Tips</h6>
                                        <small class="text-muted">8 new replies • 1 day ago</small>
                                    </div>
                                    <div class="forum-item">
                                        <h6 class="mb-1">Career Advice & Mentorship</h6>
                                        <small class="text-muted">23 new replies • 3 days ago</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Quick Actions -->
                <div class="col-md-4 mb-4">
                    <div class="card h-100">
                        <div class="card-body">
                            <h5 class="bold mb-3">Quick Actions</h5>

                            <div class="d-grid gap-2">
                                <button class="btn btn-primary">
                                    <i class="bi bi-book me-2"></i>Continue Learning
                                </button>
                                <button class="btn btn-success">
                                    <i class="bi bi-clipboard-check me-2"></i>Take Practice Test
                                </button>
                                <button class="btn btn-info">
                                    <i class="bi bi-briefcase me-2"></i>Browse Jobs
                                </button>
                                <button class="btn btn-warning">
                                    <i class="bi bi-people me-2"></i>Find Mentor
                                </button>
                                <button class="btn btn-outline-primary">
                                    <i class="bi bi-calendar-event me-2"></i>Book Session
                                </button>
                                <button class="btn btn-outline-secondary">
                                    <i class="bi bi-download me-2"></i>Resources
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Compliance Dashboard -->
            <div class="row mt-4">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="bold mb-0">Compliance Dashboard</h5>
                                <a href="#" class="btn btn-sm btn-outline-danger">View Reports</a>
                            </div>

                            <div class="row">
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-success text-white mb-2">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <h6 class="mb-1">GDPR</h6>
                                        <small class="text-success">Compliant</small>
                                    </div>
                                </div>
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-warning text-white mb-2">
                                            <i class="bi bi-exclamation-lg"></i>
                                        </div>
                                        <h6 class="mb-1">POPIA</h6>
                                        <small class="text-warning">Needs Review</small>
                                    </div>
                                </div>
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-success text-white mb-2">
                                            <i class="bi bi-check-lg"></i>
                                        </div>
                                        <h6 class="mb-1">ISO/IEC 27001</h6>
                                        <small class="text-success">Certified</small>
                                    </div>
                                </div>
                                <div class="col-md-3 text-center">
                                    <div class="compliance-item">
                                        <div class="compliance-circle bg-info text-white mb-2">
                                            <i class="bi bi-clock"></i>
                                        </div>
                                        <h6 class="mb-1">NIST</h6>
                                        <small class="text-info">In Progress</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>



<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
</script>

<style scoped>
/* Course Progress Components */
.course-item {
    padding: 0.75rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.course-item:last-child {
    border-bottom: none;
}

.progress {
    border-radius: 10px;
    overflow: hidden;
}

.progress-bar {
    border-radius: 10px;
}

/* CPD Statistics */
.cpd-stat h4 {
    font-weight: 700;
    font-size: 1.8rem;
}

/* Achievement Items */
.achievement-item {
    padding: 0.5rem 0;
}

.achievement-item:last-child {
    border-bottom: none;
}

/* Event Components */
.event-item {
    padding: 0.5rem 0;
}

.event-date>div {
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* Forum Items */
.forum-item {
    padding: 0.5rem 0;
    border-bottom: 1px solid #f5f5f5;
}

.forum-item:last-child {
    border-bottom: none;
}

.forum-item h6 {
    font-size: 0.9rem;
    color: #2c3e50;
}

/* Compliance Dashboard */
.compliance-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-size: 1.5rem;
}

.compliance-item {
    padding: 1rem;
}

/* General Styling */
.bold {
    font-weight: 600;
}

.subtitle {
    color: #6c757d;
    font-size: 0.9rem;
}

.card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
}

/* Stats Cards */
.stats_card {
    border-radius: 12px;
    transition: all 0.3s ease;
}

.stats_card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.stats_card .card-body {
    display: flex;
    align-items: center;
    padding: 1.25rem;
}

.stats_card .icon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    font-size: 1.25rem;
}

.stats_card .details {
    flex: 1;
}

.stats_card .details .subtitle {
    display: block;
    font-size: 0.8rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
}

.stats_card .details h6 {
    margin-bottom: 0;
    font-weight: 700;
}

/* Welcome Card */
#welcome-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 16px;
}

#welcome-card .card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem;
}

#welcome-card .left h2 {
    margin-bottom: 0.5rem;
    font-weight: 600;
}

#welcome-card .subtitle {
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 0;
}

.avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.2rem;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
}

/* Button Improvements */
.btn {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Responsive Design */
@media (max-width: 768px) {
    #welcome-card .card-body {
        flex-direction: column;
        text-align: center;
    }

    .avatar {
        margin-top: 1rem;
    }

    .stats_card .card-body {
        flex-direction: column;
        text-align: center;
    }

    .stats_card .icon {
        margin-right: 0;
        margin-bottom: 0.75rem;
    }

    .event-date>div {
        width: 40px;
        height: 40px;
    }

    .compliance-circle {
        width: 50px;
        height: 50px;
        font-size: 1.2rem;
    }
}
</style>
